export default __webpack_public_path__ + "static/media/share.ef3cae14.svg";